<template>
  <div id="my-content" ref="top">
    <Header/>
    <main id="root">
      <div class="profile">
        <Sidebar/>
        <div class="profile-content" :class="{'full-content': isCompany}" v-if="loadFlag">
          <form class="profile-form-edit" enctype='multipart/form-data' @submit.prevent="onSubmitAction">

            <div class="profile-form-header" v-if="isCompany">

              <div class="profile-top__background-container">

                <div class="profile-top__background-gradient"></div>

                <img v-if="backgroundImage"
                     :src="backgroundImage"
                     alt="Profile background image"
                     class="profile-top__background-image"
                     loading="lazy"
                >

                <img v-else
                     src="@/assets/img/profile-background__default.png"
                     alt="Profile background image"
                     class="profile-top__background-image"
                     loading="lazy"
                >

                <div class="profile-form__circle-avatar-container" @click.prevent.stop>
                  <div class="profile-form__circle-avatar">
                    <img v-if="avatarImage"
                         :src="avatarImage"
                         alt="song-image"
                         class="profile-form-user-photo"
                         loading="lazy"
                    >
                    <img v-else
                         src="@/assets/img/company-avatar__default.png"
                         alt="Profile image"
                         class="profile-form-user-photo artist-list-item-image-default"
                         loading="lazy"
                    >
                    <div class="profile-form-user-photo-bar">
                      <div class="profile-form-user-photo-bar-background"></div>
                      <div class="profile-form-user-photo-bar-wrap">
                        <button class="profile-form-user-photo-bar-item"
                                @click="changeImagePopup(1)"
                        >
                          <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5781 0C5.02403 0 0.521606 4.50243 0.521606 10.0565C0.521606 15.6105 5.02403 20.1129 10.5781 20.1129C16.1321 20.1129 20.6345 15.6105 20.6345 10.0565C20.6345 4.50243 16.1321 0 10.5781 0ZM12.8821 11.7759L11.5848 10.4685V16.0901H9.5735V10.4685L8.27622 11.7759L6.84821 10.3478L10.5792 6.62695L14.3101 10.3579L12.8821 11.7759ZM14.6008 6.03473H6.5556V4.02344H14.6008V6.03473Z"/>
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div class="profile-form__image-verified-item">
                      <svg v-if="isVerified"
                          width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22.2256 11.3126V12.2073C22.2244 14.3046 21.5453 16.3452 20.2896 18.025C19.0339 19.7048 17.2688 20.9336 15.2576 21.5282C13.2464 22.1229 11.0969 22.0515 9.12959 21.3247C7.1623 20.5979 5.48266 19.2546 4.34117 17.4952C3.19968 15.7358 2.6575 13.6545 2.7955 11.5618C2.93349 9.46913 3.74426 7.47709 5.10689 5.88282C6.46952 4.28854 8.311 3.17745 10.3567 2.71526C12.4024 2.25306 14.5427 2.46452 16.4584 3.3181" stroke="#459BCB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M22.2253 4.42683L12.4997 14.1622L9.58203 11.2445" stroke="#459BCB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <svg v-else
                           width="25" height="24" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.5 30.25C24.0939 30.25 30.25 24.0939 30.25 16.5C30.25 8.90608 24.0939 2.75 16.5 2.75C8.90608 2.75 2.75 8.90608 2.75 16.5C2.75 24.0939 8.90608 30.25 16.5 30.25Z" stroke="#CB8D45" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M20.625 12.375L12.375 20.625" stroke="#CB8D45" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12.375 12.375L20.625 20.625" stroke="#CB8D45" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                  </div>
                </div>

                <button class="profile-top__background-btn" @click.prevent.stop="changeBackgroundImage">
                  <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0ZM27.0408 25.7622L24.2028 22.9022V35.2002H19.8028V22.9022L16.9648 25.7622L13.8408 22.6382L22.0028 14.4982L30.1648 22.6602L27.0408 25.7622ZM30.8002 13.2004H13.2002V8.80045H30.8002V13.2004Z"
                          />
                  </svg>
                </button>

              </div>

            </div>

            <div class="profile-form-header" v-else>
              <div class="profile-form-header-top">

                <div class="profile-form-user-photo-wrap">
                  <img v-if="avatarImage"
                       :src="avatarImage"
                       alt="song-image"
                       class="profile-form-user-photo"
                       loading="lazy"
                  >
                  <img v-else
                       src="@/assets/img/default-profile-download.png"
                       alt="Profile image"
                       class="profile-form-user-photo artist-list-item-image-default"
                       loading="lazy"
                  >
                  <div class="profile-form-user-photo-bar">
                    <div class="profile-form-user-photo-bar-background"></div>
                    <div class="profile-form-user-photo-bar-wrap">
                      <div class="profile-form-user-photo-bar-item" @click.stop="changeImagePopup(2)">
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5781 0C5.02403 0 0.521606 4.50243 0.521606 10.0565C0.521606 15.6105 5.02403 20.1129 10.5781 20.1129C16.1321 20.1129 20.6345 15.6105 20.6345 10.0565C20.6345 4.50243 16.1321 0 10.5781 0ZM12.8821 11.7759L11.5848 10.4685V16.0901H9.5735V10.4685L8.27622 11.7759L6.84821 10.3478L10.5792 6.62695L14.3101 10.3579L12.8821 11.7759ZM14.6008 6.03473H6.5556V4.02344H14.6008V6.03473Z"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div class="profile-form__image-verified-item" v-if="isVerified">
                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M22.2256 11.3126V12.2073C22.2244 14.3046 21.5453 16.3452 20.2896 18.025C19.0339 19.7048 17.2688 20.9336 15.2576 21.5282C13.2464 22.1229 11.0969 22.0515 9.12959 21.3247C7.1623 20.5979 5.48266 19.2546 4.34117 17.4952C3.19968 15.7358 2.6575 13.6545 2.7955 11.5618C2.93349 9.46913 3.74426 7.47709 5.10689 5.88282C6.46952 4.28854 8.311 3.17745 10.3567 2.71526C12.4024 2.25306 14.5427 2.46452 16.4584 3.3181" stroke="#459BCB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M22.2253 4.42683L12.4997 14.1622L9.58203 11.2445" stroke="#459BCB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                  <div class="profile-form__image-verified-item" v-if="!isVerified">
                    <svg width="25" height="24" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M16.5 30.25C24.0939 30.25 30.25 24.0939 30.25 16.5C30.25 8.90608 24.0939 2.75 16.5 2.75C8.90608 2.75 2.75 8.90608 2.75 16.5C2.75 24.0939 8.90608 30.25 16.5 30.25Z" stroke="#CB8D45" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M20.625 12.375L12.375 20.625" stroke="#CB8D45" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M12.375 12.375L20.625 20.625" stroke="#CB8D45" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                  <router-link
                      :to="{path: '/profile/kyc'}"
                      class="profile-form__image-verified-text"
                      v-if="!isVerified"
                  >Verify</router-link>
                </div>

                <div class="profile-form__add_song-wrap">
                  <button class="profile-form__add_song-btn" @click.prevent.stop="checkUploadSongAction">
                    <svg class="btn-icon"
                         width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_8050_7205)">
                        <path d="M16 16L12 12L8 16" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12 12V21" stroke="#FF0090" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M20.39 18.3905C21.3653 17.8587 22.1358 17.0174 22.5798 15.9991C23.0239 14.9808 23.1162 13.8437 22.8422 12.7672C22.5682 11.6906 21.9434 10.736 21.0666 10.0539C20.1898 9.37185 19.1108 9.00121 18 9.00047H16.74C16.4373 7.82971 15.8731 6.74281 15.0899 5.82147C14.3067 4.90012 13.3248 4.16832 12.2181 3.68108C11.1113 3.19384 9.90851 2.96383 8.70008 3.00835C7.49164 3.05288 6.30903 3.37077 5.24114 3.93814C4.17325 4.5055 3.24787 5.30758 2.53458 6.28405C1.82129 7.26053 1.33865 8.38601 1.12294 9.57587C0.90723 10.7657 0.964065 11.989 1.28917 13.1537C1.61428 14.3185 2.1992 15.3943 2.99996 16.3005" stroke="#FF0090" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M16 16L12 12L8 16" stroke="#FF0090" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_8050_7205">
                          <rect width="24" height="24" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                    <span class="btn-text">Upload new song</span>
                  </button>
                </div>

              </div>

            </div>

            <div :class="{'profile-content-container': isCompany}">

              <div class="profile-head-wrapper" v-if="isCompany">

<!--                <div class="profile-head-name" v-text="fullName"></div>-->

                <div class="profile-form__add_song-wrap">
                  <button class="profile-form__add_song-btn" @click.prevent.stop="checkUploadSongAction">
                    <svg class="btn-icon"
                         width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_8050_7205)">
                        <path d="M16 16L12 12L8 16" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12 12V21" stroke="#FF0090" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M20.39 18.3905C21.3653 17.8587 22.1358 17.0174 22.5798 15.9991C23.0239 14.9808 23.1162 13.8437 22.8422 12.7672C22.5682 11.6906 21.9434 10.736 21.0666 10.0539C20.1898 9.37185 19.1108 9.00121 18 9.00047H16.74C16.4373 7.82971 15.8731 6.74281 15.0899 5.82147C14.3067 4.90012 13.3248 4.16832 12.2181 3.68108C11.1113 3.19384 9.90851 2.96383 8.70008 3.00835C7.49164 3.05288 6.30903 3.37077 5.24114 3.93814C4.17325 4.5055 3.24787 5.30758 2.53458 6.28405C1.82129 7.26053 1.33865 8.38601 1.12294 9.57587C0.90723 10.7657 0.964065 11.989 1.28917 13.1537C1.61428 14.3185 2.1992 15.3943 2.99996 16.3005" stroke="#FF0090" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M16 16L12 12L8 16" stroke="#FF0090" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_8050_7205">
                          <rect width="24" height="24" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                    <span class="btn-text">Upload new song</span>
                  </button>
                </div>

              </div>

              <div class="profile-subtitle-wrap" v-if="isCompany && profile.companyInformationDTO">
                <h2 class="profile-subtitle">Company information</h2>
              </div>
              <div class="profile-section profile-private__info-section" v-if="isCompany">
                <div class="profile-info-field-wrap">
                  <div class="profile-info-field-title">Name:</div>
                  <div class="profile-info-field profile-name" v-text="profile.companyInformationDTO.companyName"></div>
                </div>

                <div class="profile-info-field-wrap">
                  <div class="profile-info-field-title">Email:</div>
                  <div class="profile-info-field" v-text="profile.email"></div>
                </div>

                <div class="profile-info-field-wrap" v-if="profile.companyInformationDTO.companyNumber">
                  <div class="profile-info-field-title">Number:</div>
                  <div class="profile-info-field" v-text="profile.companyInformationDTO.companyNumber"></div>
                </div>

<!--                <div class="profile-info-field-wrap">-->
<!--                  <div class="profile-info-field-title">Country:</div>-->
<!--                  <div class="profile-info-field" v-text="profile.country"></div>-->
<!--                </div>-->

              </div>

              <div class="profile-subtitle-wrap" v-if="isCompany && profile.companyInformationDTO">
                <h2 class="profile-subtitle">Legal representative information</h2>
              </div>
              <div class="profile-section profile-private__info-section" v-if="isCompany">

                <div class="profile-info-field-wrap">
                  <div class="profile-info-field-title">Legal name:</div>
                  <div class="profile-info-field profile-name" v-text="fullName"></div>
                </div>

                <div class="profile-info-field-wrap">
                  <div class="profile-info-field-title">Country:</div>
                  <div class="profile-info-field" v-text="profile.country"></div>
                </div>

<!--                <div class="profile-info-field-wrap">-->
<!--                  <div class="profile-info-field-title">Date of birth:</div>-->
<!--                  <div class="profile-info-field" v-text="profile.dateOfBirth"></div>-->
<!--                </div>-->

                <div class="profile-info-field-wrap" v-if="profile.companyInformationDTO.nationality">
                  <div class="profile-info-field-title">Nationality:</div>
                  <div class="profile-info-field" v-text="profile.companyInformationDTO.nationality"></div>
                </div>

              </div>

              <div class="profile-subtitle-wrap" v-if="!isCompany">
                <h2 class="profile-subtitle">private information</h2>
              </div>
              <div class="profile-section profile-private__info-section" v-if="!isCompany">

                <div class="profile-info-field-wrap">
                  <div class="profile-info-field-title">Legal name: </div>
                  <div class="profile-info-field profile-name" v-text="fullName"></div>
                </div>

                <div class="profile-info-field-wrap">
                  <div class="profile-info-field-title">Country:</div>
                  <div class="profile-info-field" v-text="profile.country"></div>
                </div>

                <div class="profile-info-field-wrap">
                  <div class="profile-info-field-title">Date of birth:</div>
                  <div class="profile-info-field" v-text="profile.dateOfBirth"></div>
                </div>

                <div class="profile-info-field-wrap">
                  <div class="profile-info-field-title">Email:</div>
                  <div class="profile-info-field" v-text="profile.email"></div>
                </div>

              </div>

              <div class="profile-subtitle-wrap">
                <h2 class="profile-subtitle">change password</h2>
              </div>
              <div class="profile-section profile-password-section">

                <div class="profile-input-wrapper">
                  <input
                      v-model="password"
                      :type="changePasswordToggle ? 'text' : 'password'"
                      name="changePassword"
                      autocomplete="new-password"
                      id="changePassword"
                      ref="passwordRef"
                      placeholder="Change password"
                      @input="setFormData"
                      @focus="passwordFocusEvent"
                      @blur="focus = false"
                  >
                  <a href="javascript:void(0);" @click="changePasswordToggle = !changePasswordToggle"
                     class="password-show profile-password">
                    <svg class="password-svg show" :style="{display: changePasswordToggle ? 'none' : 'block'}" xmlns="http://www.w3.org/2000/svg" width="22.389" height="16.792"
                         viewBox="0 0 22.389 16.792">
                      <g transform="translate(9 -2)">
                        <g transform="translate(-9 2)">
                          <path class="a"
                                d="M11.278,2C4.2,2,0,10.4,0,10.4s4.2,8.4,11.278,8.4c6.913,0,11.11-8.4,11.11-8.4S18.191,2,11.278,2Zm-.084,13.993a5.6,5.6,0,1,1,5.6-5.6A5.6,5.6,0,0,1,11.194,15.993Zm2.8-5.6a2.8,2.8,0,1,1-2.8-2.8A2.789,2.789,0,0,1,13.993,10.4Z"
                                transform="translate(0 -2)"></path>
                        </g>
                      </g>
                    </svg>
                    <svg class="password-svg hide" :style="{display: changePasswordToggle ? 'block' : 'none'}" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="black" viewBox="0 0 16 16">
                      <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z"/>
                      <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z"/>
                    </svg>
                  </a>
                </div>
                <div class="profile-input-wrapper">
                  <input
                      v-model="passwordConfirm"
                      :type="confirmPasswordToggle? 'text' : 'password'"
                      name="confirmPassword"
                      id="confirmPassword"
                      autocomplete="new-password"
                      placeholder="Confirm password"
                      @focus="passwordFocusEvent"
                      @blur="focus = false"
                      @input="setFormData"
                  >
                  <a href="javascript:void(0);" @click="confirmPasswordToggle = !confirmPasswordToggle"
                     class="password-show profile-password">
                    <svg class="password-svg show" :style="{display: confirmPasswordToggle ? 'none' : 'block'}" xmlns="http://www.w3.org/2000/svg" width="22.389" height="16.792"
                         viewBox="0 0 22.389 16.792">
                      <g transform="translate(9 -2)">
                        <g transform="translate(-9 2)">
                          <path class="a"
                                d="M11.278,2C4.2,2,0,10.4,0,10.4s4.2,8.4,11.278,8.4c6.913,0,11.11-8.4,11.11-8.4S18.191,2,11.278,2Zm-.084,13.993a5.6,5.6,0,1,1,5.6-5.6A5.6,5.6,0,0,1,11.194,15.993Zm2.8-5.6a2.8,2.8,0,1,1-2.8-2.8A2.789,2.789,0,0,1,13.993,10.4Z"
                                transform="translate(0 -2)"></path>
                        </g>
                      </g>
                    </svg>
                    <svg class="password-svg hide" :style="{display: confirmPasswordToggle ? 'block' : 'none'}" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="black" viewBox="0 0 16 16">
                      <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z"/>
                      <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z"/>
                    </svg>
                  </a>
                </div>

                <div v-show="focus" class="password-tooltip">
                  <p class="register-new-acc-text">Password must contain:</p>
                  <div class="holder-conditions">
                    <div class="group-conditions">
                      <div class="condition-item" :class="hasMinimumLength ? 'has-required' : ''">
                        <svg :class="hasMinimumLength ? 'has-required' : ''"
                             width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                              d="M10.7862 0.20917C10.7202 0.142864 10.6419 0.0902593 10.5557 0.0543671C10.4694 0.018475 10.377 0 10.2836 0C10.1903 0 10.0978 0.018475 10.0116 0.0543671C9.92538 0.0902593 9.84705 0.142864 9.78111 0.20917L3.73653 6.28162L1.21321 3.74964C1.07993 3.61591 0.899164 3.54078 0.71068 3.54078C0.522196 3.54078 0.341431 3.61591 0.208153 3.74964C0.0748748 3.88338 0 4.06476 0 4.25389C0 4.34754 0.0183821 4.44027 0.0540971 4.52679C0.0898121 4.61331 0.14216 4.69192 0.208153 4.75814L3.23044 7.79079C3.50843 8.06974 3.9575 8.06974 4.23549 7.79079L10.7862 1.21767C11.0713 0.938722 11.0713 0.488116 10.7862 0.20917Z"
                              fill="#8692A6"/>
                        </svg>
                        <p>8 or more characters</p>
                      </div>
                      <div class="condition-item" :class="hasLowercase ? 'has-required' : ''">
                        <svg :class="hasLowercase ? 'has-required' : ''"
                             width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                              d="M10.7862 0.20917C10.7202 0.142864 10.6419 0.0902593 10.5557 0.0543671C10.4694 0.018475 10.377 0 10.2836 0C10.1903 0 10.0978 0.018475 10.0116 0.0543671C9.92538 0.0902593 9.84705 0.142864 9.78111 0.20917L3.73653 6.28162L1.21321 3.74964C1.07993 3.61591 0.899164 3.54078 0.71068 3.54078C0.522196 3.54078 0.341431 3.61591 0.208153 3.74964C0.0748748 3.88338 0 4.06476 0 4.25389C0 4.34754 0.0183821 4.44027 0.0540971 4.52679C0.0898121 4.61331 0.14216 4.69192 0.208153 4.75814L3.23044 7.79079C3.50843 8.06974 3.9575 8.06974 4.23549 7.79079L10.7862 1.21767C11.0713 0.938722 11.0713 0.488116 10.7862 0.20917Z"
                              fill="#8692A6"/>
                        </svg>
                        <p>Lowercase letter</p>
                      </div>
                      <div class="condition-item" :class="hasSpecial ? 'has-required' : ''">
                        <svg :class="hasSpecial ? 'has-required' : ''"
                             width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                              d="M10.7862 0.20917C10.7202 0.142864 10.6419 0.0902593 10.5557 0.0543671C10.4694 0.018475 10.377 0 10.2836 0C10.1903 0 10.0978 0.018475 10.0116 0.0543671C9.92538 0.0902593 9.84705 0.142864 9.78111 0.20917L3.73653 6.28162L1.21321 3.74964C1.07993 3.61591 0.899164 3.54078 0.71068 3.54078C0.522196 3.54078 0.341431 3.61591 0.208153 3.74964C0.0748748 3.88338 0 4.06476 0 4.25389C0 4.34754 0.0183821 4.44027 0.0540971 4.52679C0.0898121 4.61331 0.14216 4.69192 0.208153 4.75814L3.23044 7.79079C3.50843 8.06974 3.9575 8.06974 4.23549 7.79079L10.7862 1.21767C11.0713 0.938722 11.0713 0.488116 10.7862 0.20917Z"
                              fill="#8692A6"/>
                        </svg>
                        <p>Symbols</p>
                      </div>
                      <div class="condition-item" :class="hasUppercase ? 'has-required' : ''">
                        <svg :class="hasUppercase ? 'has-required' : ''"
                             width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                              d="M10.7862 0.20917C10.7202 0.142864 10.6419 0.0902593 10.5557 0.0543671C10.4694 0.018475 10.377 0 10.2836 0C10.1903 0 10.0978 0.018475 10.0116 0.0543671C9.92538 0.0902593 9.84705 0.142864 9.78111 0.20917L3.73653 6.28162L1.21321 3.74964C1.07993 3.61591 0.899164 3.54078 0.71068 3.54078C0.522196 3.54078 0.341431 3.61591 0.208153 3.74964C0.0748748 3.88338 0 4.06476 0 4.25389C0 4.34754 0.0183821 4.44027 0.0540971 4.52679C0.0898121 4.61331 0.14216 4.69192 0.208153 4.75814L3.23044 7.79079C3.50843 8.06974 3.9575 8.06974 4.23549 7.79079L10.7862 1.21767C11.0713 0.938722 11.0713 0.488116 10.7862 0.20917Z"
                              fill="#8692A6"/>
                        </svg>
                        <p>Uppercase letter</p>
                      </div>
                      <div class="condition-item" :class="hasNumber ? 'has-required' : ''">
                        <svg :class="hasNumber ? 'has-required' : ''"
                             width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                              d="M10.7862 0.20917C10.7202 0.142864 10.6419 0.0902593 10.5557 0.0543671C10.4694 0.018475 10.377 0 10.2836 0C10.1903 0 10.0978 0.018475 10.0116 0.0543671C9.92538 0.0902593 9.84705 0.142864 9.78111 0.20917L3.73653 6.28162L1.21321 3.74964C1.07993 3.61591 0.899164 3.54078 0.71068 3.54078C0.522196 3.54078 0.341431 3.61591 0.208153 3.74964C0.0748748 3.88338 0 4.06476 0 4.25389C0 4.34754 0.0183821 4.44027 0.0540971 4.52679C0.0898121 4.61331 0.14216 4.69192 0.208153 4.75814L3.23044 7.79079C3.50843 8.06974 3.9575 8.06974 4.23549 7.79079L10.7862 1.21767C11.0713 0.938722 11.0713 0.488116 10.7862 0.20917Z"
                              fill="#8692A6"/>
                        </svg>
                        <p>Numbers</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="pass-field-error" v-if="!requireRulesForPassword && focus">
                  <div class="phone-field-error-msg pass-field-error-msg">Your password doesn't fit the requirements</div>
                </div>

                <div class="pass-field-error" v-if="compareFailed">

                  <div class="phone-field-error-msg pass-field-error-msg">The passwords must match
                  </div>
                </div>

              </div>

              <div class="profile-subtitle-wrap">
                <h2 class="profile-subtitle">public information</h2>
              </div>
              <div class="profile-section profile-public__info-section">
                <div class="profile-public__info-about">

                  <div class="profile-input-wrapper" v-if="!isCompany">
                    <input type="text"
                           name="publicInformation.stageName"
                           id="id_stage_name"
                           placeholder="Stage name"
                           v-model="profile.publicInformationDTO.stageName"
                           @input="setFormData"
                           @blur="$v.profile.publicInformationDTO.stageName.$touch()"
                    >
                    <span class="error-profile" v-if="!$v.profile.publicInformationDTO.stageName.maxLength">
                      The maximum length of a text message is {{ $v.profile.publicInformationDTO.stageName.$params.maxLength.max }} characters
                    </span>
                    <span class="error-profile" v-if="!$v.profile.publicInformationDTO.stageName.minLength">
                      The minimum length of a text message is {{ $v.profile.publicInformationDTO.stageName.$params.minLength.min }} characters
                    </span>
                  </div>

                  <div class="profile-input-wrapper" v-if="!isCompany">
                    <input type="text" name="headline" id="id_headline"
                           placeholder="Description (ex.&quot;singer&quot;, &quot;songwriter&quot;)"
                           v-model="profile.headline" @input="setFormData"
                           @blur="$v.profile.headline.$touch()"
                    >
                    <span class="error-profile" v-if="!$v.profile.headline.maxLength">
                      The maximum length of a text message is {{ $v.profile.headline.$params.maxLength.max }} characters
                    </span>
                    <span class="error-profile" v-if="!$v.profile.headline.minLength">
                      The minimum length of a text message is {{ $v.profile.headline.$params.minLength.min }} characters
                    </span>
                  </div>

                  <div class="profile-textarea-wrap">
                  <textarea class="profile-textarea"
                            name="description"
                            id="id_description"
                            :placeholder="isCompany ? 'About company…' : 'About myself…'"
                            v-model="profile.description"
                            @input="setFormData"
                            @blur="$v.profile.description.$touch()"
                  >
                  </textarea>
                  </div>

                  <span class="error-profile" v-if="!$v.profile.description.maxLength">
                      You can’t use more than {{ $v.profile.description.$params.maxLength.max }} characters for your bio
                  </span>
                  <span class="error-profile" v-if="!$v.profile.description.minLength">
                      Please use at least {{ $v.profile.description.$params.minLength.min }} characters for your bio
                  </span>
                </div>

                <div class="profile-public__info-video video-empty">

                  <div class="video-wrapper" v-if="profileVideo !== ''" @click="togglePlayVideo">
                    <div class="play-button play-button-video">
                      <div class="hitparad_button-play"
                           :class="videoButtonFlag ? 'hitparad_button-play-active' : 'hitparad_button-pause'"
                      ></div>
                    </div>
                    <video class="my-video" :src="profileVideo" ref="videoRef"></video>
                  </div>

                  <div class="video-preview" v-else>
                    <img src="../assets/img/video_upload.png" alt="Video preview" loading="lazy">
                  </div>

                  <div class="profile-video-hover">
                    <div class="profile-video-hover-download">
                      <svg width="56" height="39" viewBox="0 0 56 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M44.8 5.57143C44.8 4.09379 44.21 2.67668 43.1598 1.63183C42.1096 0.586988 40.6852 0 39.2 0H5.6C4.11479 0 2.69041 0.586988 1.6402 1.63183C0.589998 2.67668 0 4.09379 0 5.57143V33.4286C0 34.9062 0.589998 36.3233 1.6402 37.3682C2.69041 38.413 4.11479 39 5.6 39H39.2C40.6852 39 42.1096 38.413 43.1598 37.3682C44.21 36.3233 44.8 34.9062 44.8 33.4286V24.1438L56 33.4286V5.57143L44.8 14.8562V5.57143ZM33.6 22.2857H25.2V30.6429H19.6V22.2857H11.2V16.7143H19.6V8.35714H25.2V16.7143H33.6V22.2857Z"
                              fill="#B6B6B6"/>
                      </svg>
                      <input type="file" id="id_profile_video" name="fileVideo" class="video-download-btn"
                             accept=".mp4, .m4a, .mov, .ogg, .wmv" @change="setVideo">
                    </div>



                  </div>

                </div>

                <div class="public-info">

                  <GeneralSelect class="public-info-select"
                                 :identifier="'profile-info-type'"
                                 :options="publicInfo.types"
                                 :placeholder="'Type'"
                                 :current="currentInfoType"
                                 @changed="setInfoType"
                  />

                  <GeneralSelect class="public-info-select"
                                 :identifier="'profile-info-genre'"
                                 :options="publicInfo.genres"
                                 :placeholder="'Genre'"
                                 :current="currentInfoGenre"
                                 @changed="setInfoGenre"
                  />

                  <GeneralSelect class="public-info-select"
                                 :identifier="'profile-info-status'"
                                 :options="publicInfo.statuses"
                                 :placeholder="'Status'"
                                 :current="currentInfoStatus"
                                 @changed="setInfoStatus"
                  />

                  <GeneralSelect class="public-info-select"
                                 id="socialRef"
                                 :identifier="'profile-info-repertoire'"
                                 :options="publicInfo.songRepertoires"
                                 :placeholder="'Song repertoire'"
                                 :current="currentInfoRepertoire"
                                 @changed="setInfoRepertoire"
                  />

                </div>
              </div>

              <div class="profile-subtitle-wrap">
                <h2 class="profile-subtitle">web &#38; social links<br><span class="addendum">(Please check media contact link)</span></h2>
              </div>
              <div class="registration-form-item registration-social-wrap">
                <div class="registration-field-wrap registration-social-field">
                  <div class="input-wrap">
                    <!--<input type="checkbox" class="checkbox" name="display_twitter" id="id_display_twitter"
                           value="False"
                           >-->
                    <div class="profile-social-input">
                      <div class="registr-input-img-wrap registr-input-img-wrap-twitter">
                        <img src="https://static.djookyawards.com/static/img/twitter-reg.svg" alt="icon" loading="lazy">
                      </div>
                      <input
                          type="text"
                          name="socialLinks.twitter"
                          id="id_twitter"
                          placeholder="Link"
                          v-model.trim="profile.links.twitter"
                          @input="setFormData"
                          @blur="$v.profile.links.twitter.$touch()"
                      >
                      <span class="error-profile"
                            v-if="!$v.profile.links.twitter.maxLength"
                      >
                      The maximum length of a text message is {{ $v.profile.links.twitter.$params.maxLength.max }} characters
                    </span>
                    </div>
                  </div>

                </div>
                <div class="registration-field-wrap registration-social-field">
                  <div class="input-wrap">
                    <div class="profile-social-input">
                      <div class="registr-input-img-wrap registr-input-img-wrap-instagram">
                        <img src="https://static.djookyawards.com/static/img/instagramm-reg.svg" alt="icon" loading="lazy">
                      </div>
                      <input type="text" name="socialLinks.instagram" id="id_instagram" placeholder="Link"
                             v-model.trim="profile.links.instagram"
                             @input="setFormData"
                             @blur="$v.profile.links.instagram.$touch()"
                      >
                      <span class="error-profile"
                            v-if="!$v.profile.links.instagram.maxLength"
                      >
                      The maximum length of a text message is {{ $v.profile.links.instagram.$params.maxLength.max }} characters
                    </span>
                    </div>
                  </div>

                </div>
                <div class="registration-field-wrap registration-social-field">
                  <div class="input-wrap">
                    <!--<input type="checkbox" class="checkbox" name="display_facebook" id="id_display_facebook"
                           value="False"
                           >-->
                    <div class="profile-social-input">
                      <div class="registr-input-img-wrap registr-input-img-wrap-facebook">
                        <img src="https://static.djookyawards.com/static/img/facebook-reg.svg" alt="icon" loading="lazy">
                      </div>
                      <input type="text" name="socialLinks.facebook" id="id_facebook" placeholder="Link"
                             v-model.trim="profile.links.facebook"
                             @input="setFormData"
                             @blur="$v.profile.links.facebook.$touch()"
                      >
                      <span class="error-profile"
                            v-if="!$v.profile.links.facebook.maxLength"
                      >
                      The maximum length of a text message is {{ $v.profile.links.facebook.$params.maxLength.max }} characters
                    </span>
                    </div>
                  </div>

                </div>
                <div class="registration-field-wrap registration-social-field">
                  <div class="input-wrap">
                    <!--<input type="checkbox" class="checkbox" name="display_website"
                           id="id_display_website"
                           value="False"
                           >-->
                    <div class="profile-social-input">
                      <div class="registr-input-img-wrap registr-input-img-wrap-website">
                        <img src="https://static.djookyawards.com/static/img/circle-reg.svg" alt="icon" loading="lazy">
                      </div>
                      <input type="text" name="socialLinks.website" id="id_website" placeholder="Link"
                             v-model.trim="profile.links.website"
                             @input="setFormData"
                             @blur="$v.profile.links.website.$touch()"
                      >
                      <span class="error-profile"
                            v-if="!$v.profile.links.website.maxLength"
                      >
                      The maximum length of a text message is {{ $v.profile.links.website.$params.maxLength.max }} characters
                    </span>
                    </div>
                  </div>

                </div>
              </div>

              <div class="profile-subtitle-wrap">
<!--                <h2 class="profile-subtitle" v-if="!isCompany">Add new Song</h2>-->
              </div>

              <div class="profile-section profile-checkbox-wrapper" v-if="!isCompany">

                <!--              wait for backend, currently blocked-->

                <!--              <div class="profile-checkbox-item">-->
                <!--                <GeneralCustomCheckBox :checkBoxId="'profile-receive_letters'"-->
                <!--                                       :disabledCheckBox="true"-->
                <!--                                       :currentStatus="checkboxLettersVal"-->
                <!--                                       @checked="setReceiveLettersStatus"-->
                <!--                />-->
                <!--                <p class="profile-checkbox-description">-->
                <!--                  To receive letters-->
                <!--                  <span class="info hint hint&#45;&#45;right" data-hint="This functionality will appear in the near future!">-->
                <!--                    <svg height="512pt" viewBox="0 0 512 512" width="512pt"-->
                <!--                         xmlns="http://www.w3.org/2000/svg"><path-->
                <!--                        d="m277.332031 128c0 11.78125-9.550781 21.332031-21.332031 21.332031s-21.332031-9.550781-21.332031-21.332031 9.550781-21.332031 21.332031-21.332031 21.332031 9.550781 21.332031 21.332031zm0 0"></path><path-->
                <!--                        d="m256 405.332031c-8.832031 0-16-7.167969-16-16v-165.332031h-21.332031c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h37.332031c8.832031 0 16 7.167969 16 16v181.332031c0 8.832031-7.167969 16-16 16zm0 0"></path><path-->
                <!--                        d="m256 512c-141.164062 0-256-114.835938-256-256s114.835938-256 256-256 256 114.835938 256 256-114.835938 256-256 256zm0-480c-123.519531 0-224 100.480469-224 224s100.480469 224 224 224 224-100.480469 224-224-100.480469-224-224-224zm0 0"></path><path-->
                <!--                        d="m304 405.332031h-96c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h96c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"></path></svg>-->
                <!--                </span>-->
                <!--                </p>-->
                <!--              </div>-->

                <!--              &#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;-->

                <div class="profile-checkbox-item">
                  <GeneralCustomCheckBox :checkBoxId="'profile-is_artist'"
                                         :disabledCheckBox="disableArtistCheckbox"
                                         :currentStatus="checkboxArtistVal"
                                         @checked="setArtistStatus"

                  />
                  <p class="profile-checkbox-description">
                    Register as an Artist
                    <span class="info hint hint--right" data-hint="If you are an artist and wish to upload a song and start the initial sale of your composition, please click the checkbox. After that, your profile will appear on the Artists page.">
                    <svg height="512pt" viewBox="0 0 512 512" width="512pt"
                         xmlns="http://www.w3.org/2000/svg"><path
                        d="m277.332031 128c0 11.78125-9.550781 21.332031-21.332031 21.332031s-21.332031-9.550781-21.332031-21.332031 9.550781-21.332031 21.332031-21.332031 21.332031 9.550781 21.332031 21.332031zm0 0"></path><path
                        d="m256 405.332031c-8.832031 0-16-7.167969-16-16v-165.332031h-21.332031c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h37.332031c8.832031 0 16 7.167969 16 16v181.332031c0 8.832031-7.167969 16-16 16zm0 0"></path><path
                        d="m256 512c-141.164062 0-256-114.835938-256-256s114.835938-256 256-256 256 114.835938 256 256-114.835938 256-256 256zm0-480c-123.519531 0-224 100.480469-224 224s100.480469 224 224 224 224-100.480469 224-224-100.480469-224-224-224zm0 0"></path><path
                        d="m304 405.332031h-96c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h96c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"></path></svg>
                </span>
                  </p>
                </div>

            </div>

            </div>

            <div class="profile-btn-wrap">
              <button id="user-submit-button"
                      type="submit"
                      class="btn btn-hover profile-btn"
                      name="user_submit"
              >Save Changes</button>
            </div>

          </form>
        </div>

        <div class="preloader-wrapper profile-preloader" v-else>
          <v-progress-circular
              :size="75"
              :width="8"
              color="#FF0090"
              indeterminate
          ></v-progress-circular>
        </div>

      </div>

      <SuccessPopup ref="successPopup" :error-message="successChange"/>

<!--      :imageSrc="image.src"-->
      <CropImagePopup
          ref="cropImagePopup"
          :defaultImage="defaultAvatar"
          :index="cropPopupIndex"
          :aspectRatio="aspectRatio"
          :border-radius="'50%'"
          @cropImage="cropImage"
      />
      <CropImagePopup
          ref="cropBackgroundImagePopup"
          :defaultImage="defaultBackground"
          :aspectRatio="aspectRatio"
          :border-radius="'0'"
          @cropImage="cropBackgroundImage"
      />
<!--      <PhoneVerifyPopup ref="phoneVerifyProfile" :phoneVal="phone" @confirmAction="confirmPhoneNumber"/>-->
      <ServerErrorPopup ref="serverErrorPopup" :errorMessage="error.errorMessage" :errorTitle="error.errorTitle"/>

    </main>
    <Footer/>
  </div>
</template>

<script>

// import DatePicker from "vue2-datepicker";
import Sidebar from "../components/profile/Sidebar";
import Footer from "../components/footer/Footer";
import Header from "../components/header/Header";
// import PhoneVerifyPopup from '../components/popups/PhoneVerifyPopup'
import ServerErrorPopup from "../components/popups/ServerErrorPopup";
import SuccessPopup from "../components/popups/SuccessPopup";
import CropImagePopup from "../components/popups/CropImagePopup";
import {mapActions} from 'vuex';
import {maxLength, minLength} from "vuelidate/lib/validators";
import GeneralSelect from "../components/inputs/GeneralSelect";
import GeneralCustomCheckBox from "@/components/inputs/GeneralCustomCheckBox";
import scrollToElement from "@/mixins/scrollToElement";


export default {
  name: "Profile",
  data() {
    return {
      // fake data
      fakeCroppedImage: '',
      cropPopupIndex: null,
      aspectRatio: null,
      timeoutId: null,
      // end fake data
      tabs: JSON.parse(localStorage.getItem('tabs')),
      // environment: process.env.VUE_APP_BASE_URL,
      // localHost: false,
      // phoneDisabledFlag: false,
      headerUserPhoto: '',
      changePasswordToggle: false,
      confirmPasswordToggle: false,
      dateOfBirthData: '',
      verifyButtonText: 'Verify me',
      avatarImage: '',
      backgroundImage: '',
      password: null,
      passwordConfirm: null,
      successChange: 'Your changes have been saved',
      focus: false,
      hasMinimumLength: false,
      hasNumber: false,
      hasLowercase: false,
      hasUppercase: false,
      hasSpecial: false,
      compareFailed: false,
      requireRulesForPassword: true,
      // phone: '',
      // saveChangesFlag: false,
      // profilePhoneNumber: '',
      profile: {},
      loadFlag: false,
      user: JSON.parse(localStorage.getItem('user')),
      checkboxArtistVal: null,
      // checkboxLettersVal: null,
      fakeData: '',
      videoFlag: false,
      profileVideo: '',
      videoButtonFlag: false,
      // bankAndAddressDetails: {},
      // showModal: true,
      // disabledCLass: true,
      // checkMoney: null,
      formData: new FormData(),
      error: {
        // phoneError: '',
        errorMessage: '',
        errorTitle: '',
      },
      currentInfoType: null,
      currentInfoGenre: null,
      currentInfoStatus: null,
      currentInfoRepertoire: null,
      publicInfo: {},
      // validNumber: null,
      // hasPlus: null,
      // phoneIsNotValid: false,
      // phoneIsNotValidError: '',
      checkUploadSong: {},
      image: {
        src: '',
      },
      // defaultImage: null,
      defaultAvatar: 'data:image/png;base64,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',
      defaultBackground: 'data:image/jpeg;base64,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',
    }
  },
  validations() {
    return {
      profile: {
        headline: {
          maxLength: maxLength(50),
          minLength: minLength(15)
        },
        description: {
          maxLength: maxLength(1000),
          minLength: minLength(50)
        },
        publicInformationDTO: {
          stageName: {
            maxLength: maxLength(100),
            minLength: minLength(2)
          },
        },
        links: {
          twitter: {
            maxLength: maxLength(150)
          },
          instagram: {
            maxLength: maxLength(150)
          },
          facebook: {
            maxLength: maxLength(150)
          },
          website: {
            maxLength: maxLength(150)
          },
        },
      },
    }
  },
  mixins: [scrollToElement],
  computed: {
    // isPhoneNumberValid() {
    //   return this.hasPlus && this.validNumber
    // },
    disableArtistCheckbox() {
      return this.checkboxArtistVal
    },
    fullName() {
      return this.profile.firstName + ' ' + this.profile.lastName
    },
    isVerified() {
      return this.tabs.kycTab.kycFlow === 'NONE'
    },
    isCompany() {
      return this.profile.userType !== 'ARTIST' && this.profile.userType !== 'INVESTOR' && this.profile.userType !== 'SERVICE_PROVIDER'
    },
  },
  methods: {
    ...mapActions({
      setMoney: 'money/setMoney',
      setTabs: 'userTabs/setTabs',
    }),
    passwordFocusEvent() {
      this.focus = true
      setTimeout(() => {

        window.scrollBy(0, 1)
      }, 0)
    },
    comparePass() {
      if (this.password === null && this.passwordConfirm === null) {
        return true
      } else {
        if (this.checkFake() && this.requireRulesForPassword) {
          return true
        } else {
          this.compareFailed = true
          this.scrollToId('changePassword')
        }
      }
    },
    developmentNotification() {
      this.error.errorMessage = 'Functional in development'
      this.$refs.serverErrorPopup.openPopups()
    },
    // setAvatar(e) {
    //   const name = e.target.name
    //   const files = e.target.files || e.dataTransfer.files;
    //   if (!files.length) return;
    //   this.formData.set(name, files[0])
    //   this.createImage(files[0]);
    // },
    setVideo(e) {
      const name = e.target.name
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.formData.set(name, files[0])
      this.createVideo(files[0]);
    },
    // createImage(file) {
    //   const reader = new FileReader();
    //   const vm = this;
    //
    //   reader.onload = (e) => {
    //     vm.avatarImage = e.target.result;
    //   };
    //   reader.readAsDataURL(file);
    // },
    createVideo(file) {
      const reader = new FileReader();
      const vm = this;

      reader.onload = (e) => {
        vm.profileVideo = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    // confirmPhoneNumber(value) {
    //   this.formData.phoneNumber = value.replaceAll(' ', '').toString()
    //   this.saveChangesFlag = false
    // },
    setFormData(event) {
      let dataKey = event.target.name
      let val = event.target.value
      this.formData.set(dataKey, val)
      // console.log(dataKey)
      // console.log(val)
    },
    checkFake() {
      if (this.password.length > 0) {
        return this.password === this.passwordConfirm
      } else {
        return true
      }
    },
    // phoneInput(val, val2) {
    //   let oldNumberPhone = new String(this.profilePhoneNumber).valueOf()
    //   let newNumberPhone = new String(val2.number).valueOf()
    //
    //   if (oldNumberPhone !== newNumberPhone) {
    //     this.saveChangesFlag = true
    //     this.disabledCLass = false
    //   } else {
    //     this.disabledCLass = true
    //     this.saveChangesFlag = false
    //   }
    // },
    dataRequest() {
      this.$load(async () => {
        this.loadFlag = false
        let res = (await this.$api.profile.getAll())
        this.profile = res.data.body

        this.checkboxArtistVal = this.profile.artist
        // let res = await this.$api.profile.getBankAndAddressDetails(this.profile.uuid)
        // if (this.profile.phoneNumber !== null) {
        //   this.phone = this.profile.phoneNumber
        // } else {
        //   this.phone = ''
        // }
        this.dateOfBirthData = new Date(this.profile.dateOfBirth)
        this.avatarImage = this.profile.photo
        this.profileVideo = this.profile.video
        if (this.profile.companyInformationDTO) {
          this.backgroundImage = this.profile.companyInformationDTO.backgroundPhoto
        }
        // this.profilePhoneNumber = this.profile.phoneNumber.replaceAll(' ', '')
        let type = this.profile.publicInformationDTO.type
        let genre = this.profile.publicInformationDTO.genre
        let status = this.profile.publicInformationDTO.status
        let repertoire = this.profile.publicInformationDTO.songRepertoire
        if (type !== null && type !== '') {
          this.currentInfoType = this.publicInfo.types.find(i => i.value === type)
        }
        if (genre !== null && genre !== '') {
          this.currentInfoGenre = this.publicInfo.genres.find(i => i.value === genre)
        }
        if (status !== null && status !== '') {
          this.currentInfoStatus = this.publicInfo.statuses.find(i => i.value === status)
        }
        if (repertoire !== null && repertoire !== '') {
          this.currentInfoRepertoire = this.publicInfo.songRepertoires.find(i => i.value === repertoire)
        }
        await this.$store.dispatch('user/setUser', {
          userPhoto: this.profile.photo,
          userName: this.profile.firstName,
          userType: this.profile.userType
        })
        this.loadFlag = true
      })
    },
    getRequestParamsPublicInfo(userType) {
      let params = {}
      if (userType !== 'COMPANY') {
        // able be: artist, company, associated-artist
        params['rule-key'] = 'artist'
      } else {
        params['rule-key'] = userType.toLowerCase()
      }
      return params
    },
    requestPublicInfo() {
      const params = this.getRequestParamsPublicInfo(this.user.user_type)
      this.$load(async () => {
        let res = await this.$api.profile.getPublicInfo(params)
        let data = res.data.body
        this.publicInfo['types'] = this.getObjToArray(data.types)
        this.publicInfo['statuses'] = this.getObjToArray(data.statuses)
        this.publicInfo['songRepertoires'] = this.getObjToArray(data.songRepertoires)
        this.publicInfo['genres'] = this.getArrayToFormat(data.genres)
      })
    },
    getObjToArray(obj) {
      let newArray = []
      for (let i in obj) {
        let newObj = {}
        newObj['value'] = +i
        newObj['name'] = obj[i]
        newArray.push(newObj)
      }
      return newArray
    },
    getArrayToFormat(array) {
      let newArray = []
      for (let i in array) {
        let newObj = {}
        newObj['value'] = array[i]
        newObj['name'] = array[i]
        newArray.push(newObj)
      }
      return newArray
    },
    onSubmitAction() {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      } else {
        if (this.comparePass()) {
          this.$load(async () => {
            await this.$api.profile.changeProfile(this.formData)
            this.password = ''
            this.passwordConfirm = ''
            this.compareFailed = false
            this.$refs.successPopup.openPopups()
            setTimeout(() => {
              this.requestPublicInfo()
              this.dataRequest()
              this.scrollToId('my-content')
              this.checkUploadSongInfo()
            }, 500)

          }, (error) => {
            this.error.errorMessage = error.data.errors[0].message
            this.$refs.serverErrorPopup.openPopups()
          })
        }
      }
    },
    // openPopupForm() {
    //   if (this.isPhoneNumberValid) {
    //     this.verifyButtonText = 30
    //     this.disabledCLass = true
    //     this.phoneDisabledFlag = true
    //     const interval = setInterval(() => {
    //       this.verifyButtonText--
    //       if (this.verifyButtonText === 0) {
    //         this.verifyButtonText = 'Resend'
    //         this.disabledCLass = false
    //         this.phoneDisabledFlag = false
    //         clearInterval(interval)
    //       }
    //     }, 1000)
    //     this.$load(async () => {
    //       await this.$api.auth.dispatch({phoneNumber: this.phone}).then(() => {
    //         this.$refs.phoneVerifyProfile.openPopups()
    //       })
    //     }, (error) => {
    //       this.error.errorMessage = error.data.errors[0].message
    //       this.$refs.serverErrorPopup.openPopups()
    //       this.compareFailed = false
    //     })
    //   }
    // },
    togglePlayVideo() {
      this.videoFlag = !this.videoFlag
    },
    setDate(val) {
      let date = new Date(val)
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let dt = date.getDate();

      if (dt < 10) {
        dt = '0' + dt
      }
      if (month < 10) {
        month = '0' + month
      }

      let dateOfBirth = year + '-' + month + '-' + dt;
      if (val === null) {
        this.formData.set('dateOfBirth', '')
      }
      this.formData.set('dateOfBirth', dateOfBirth)
    },
    changeImagePopup(index) {
      this.cropPopupIndex = index

      let collection = document.getElementsByClassName('vue-rectangle-stencil__preview')
      let item = collection.item(0)
      if (index === 1) {

        if (this.$refs.cropImagePopup.$refs.cropper) {
          this.$refs.cropImagePopup.$refs.cropper.reset()
        }

        // let waitingEL = () => {
        //
        //   let i = collection.item(0)
        //   if (i) {
        //     i.style.borderRadius = '50%'
        //   } else {
        //     this.timeoutId = setTimeout(waitingEL, 300)
        //   }
        // }
        // waitingEL()
        // setTimeout(() => {
        //   clearTimeout(this.timeoutId)
        // }, 3000)

        // this.defaultImage = this.defaultAvatar
        this.aspectRatio = 1

      } else if (index === 2) {
        if (this.$refs.cropImagePopup.$refs.cropper) {
          this.$refs.cropImagePopup.$refs.cropper.reset()
        }
        // setTimeout(() => {
        //   if (item) {
        //     item.style.borderRadius = '0'
        //   }
        // })
        // this.defaultImage = this.defaultAvatar
        this.aspectRatio = 3/2
      }
      this.$refs.cropImagePopup.openPopups()
    },
    changeBackgroundImage() {
      let collection = document.getElementsByClassName('vue-rectangle-stencil__preview')
      let item = collection.item(0)
      if (this.$refs.cropBackgroundImagePopup.$refs.cropper) {
        this.$refs.cropBackgroundImagePopup.$refs.cropper.reset()
      }
      // setTimeout(() => {
      //   if (item) {
      //     item.style.borderRadius = '0'
      //   }
      // })
      // this.defaultImage = this.defaultBackground
      this.aspectRatio = 5

      this.$refs.cropBackgroundImagePopup.openPopups()
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      let byteCharacters = atob(b64Data);
      let byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);

        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        let byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      let blob = new Blob(byteArrays, {type: contentType});
      return blob;
    },
    cropImage(imageUrl) {
      let block = imageUrl.split(";");
      let contentType = block[0].split(":")[1];// In this case "image/gif"
      let realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."
      let blob = this.b64toBlob(realData, contentType);

      this.avatarImage = imageUrl
      this.formData.set('fileAvatar', blob, 'avatar')
    },
    cropBackgroundImage(imageUrl) {
      let block = imageUrl.split(";");
      let contentType = block[0].split(":")[1];// In this case "image/gif"
      let realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."
      let blob = this.b64toBlob(realData, contentType);

      this.backgroundImage = imageUrl
      this.formData.set('fileBackgroundPhoto', blob, 'background')
    },
    checkUploadSongInfo() {
      this.$load(async () => {
        await this.$api.profileSongs.checkUploadSong().then(res => {
          this.checkUploadSong = res.data.body
        })
      }, error => {
        this.error.serverError = error.data.errors[0].message
        this.$refs.serverErrorPopup.openPopups()
      })
    },
    checkUploadSongAction() {
      if(this.checkUploadSong.accessForUploadSong) {
        this.$router.push({path: '/profile/create-song'}).catch(()=>{})
        this.scrollToId('my-content')
      } else {
        this.error.errorTitle = 'Oops'
        // this.error.errorMessage = `${this.checkUploadSong.errorMessage} <br> go to <a href="${this.addQueryForRedirectUrl('profile', 'socialRef')}">your profile</a>`
        let url = this.checkUploadSong.redirectUrl
        if (url.includes('associated')) {
          this.error.errorMessage = `${this.checkUploadSong.errorMessage} <br> <a href="${url}">to the page</a>`
          this.$refs.serverErrorPopup.openPopups()
          return
        }

        this.error.errorMessage = `${this.checkUploadSong.errorMessage} <br> <a href="${this.redirectUrlWithQuery(url, 'socialRef')}">to the page</a>`
        this.$refs.serverErrorPopup.openPopups()
      }
    },
    redirectUrlWithQuery(url, scrollTo) {
      if (url && scrollTo) {
        return url + '?' + scrollTo
      }
    },
    // addQueryForRedirectUrl(page, scrollTo) {
    //   let url = this.checkUploadSong.redirectUrl
    //   if (url.includes('associated')) {
    //     return page
    //   }
    //
    //   let pageStr = page.toString()
    //   if (url.includes(pageStr)) {
    //     // for local debugging, link from backend does not contain a local link
    //     let urlEnding = '?' + scrollTo
    //     let urlMain = url + urlEnding
    //     if (this.localHost) {
    //       let local = this.environment
    //       let localToHttp = local.replace(/^(https:)/g, 'http:')
    //       return localToHttp + pageStr + '/' + urlEnding
    //     } else {
    //       return urlMain
    //     }
    //   }
    // },
    // checkLocalHost() {
    //   this.environment.includes('localhost') ? this.localHost = true : this.localHost = false
    // },
    setInfoType(data) {
      this.formData.set('publicInformation.type', data)
    },
    setInfoGenre(data) {
      this.formData.set('publicInformation.genre', data)
    },
    setInfoStatus(data) {
      this.formData.set('publicInformation.status', data)
    },
    setInfoRepertoire(data) {
      this.formData.set('publicInformation.songRepertoire', data)
    },
    setArtistStatus(data) {
      this.formData.set('isArtist', data)
    },

    // wait for backend
    // setReceiveLettersStatus(data) {
    //   // this.formData.set('receiveLetters', data)
    // },
  },
  watch: {
    dateOfBirthData(newVal) {
      this.setDate(newVal)
    },
    videoFlag(newVal) {
      if (newVal) {
        this.$refs.videoRef.play();
        this.videoButtonFlag = true
      } else {
        this.$refs.videoRef.pause()
        this.videoButtonFlag = false
      }
    },
    // checkboxArtistVal(newVal) {
    //   // this.formData.set('isArtist', newVal)
    //   console.log('newVal: ', newVal)
    // },
    // phone(newVal) {
    //   let phone = newVal.replace('+', '').replaceAll(' ', '')
    //   let phoneNumber = Number(phone)
    //   if (phoneNumber) {
    //     this.validNumber = true
    //     this.phoneIsNotValidError = ''
    //     this.phoneIsNotValid = false
    //   } else {
    //     this.validNumber = false
    //     this.phoneIsNotValidError = 'Phone must contain only numbers'
    //     this.phoneIsNotValid = true
    //     return
    //   }
    //   if (newVal[0] !== '+') {
    //     this.hasPlus = false
    //     this.phoneIsNotValidError = 'Incorrect phone number'
    //     this.phoneIsNotValid = true
    //   } else {
    //     this.hasPlus = true
    //     this.phoneIsNotValidError = ''
    //     this.phoneIsNotValid = false
    //   }
    //
    //   if (newVal === '') {
    //     this.disabledCLass = true
    //   }
    // },
    password(newVal) {
      if (newVal) {
        this.hasMinimumLength = (newVal.length >= 8);
        this.hasNumber = /\d/.test(newVal);
        this.hasLowercase = /[a-z]/.test(newVal);
        this.hasUppercase = /[A-Z]/.test(newVal);
        this.hasSpecial = /[#?!@$%/^()}{><.&|:;`',*~"-]/.test(newVal);
        if (this.hasMinimumLength && this.hasNumber && this.hasLowercase && this.hasUppercase && this.hasSpecial) {
          this.requireRulesForPassword = true;
        } else {
          this.requireRulesForPassword = false;
        }
        if (newVal === '') {
          this.password = null
        }
      }
    },
    passwordConfirm(newVal) {
      if (newVal === '') {
        this.passwordConfirm = null
      }
    },
  },
  mounted() {
    document.title = 'Profile'

    this.requestPublicInfo()
    setTimeout(() => {
      this.dataRequest()
    }, 500)
    this.setMoney()

    this.checkUploadSongInfo()
    // this.checkLocalHost()
    let href = window.location.href
    let id = 'socialRef'
    setTimeout(() => {
      if (href.includes(id)) {
        this.scrollToId(`${id}`)
      } else {
        this.scrollToId('my-content')
      }
    }, 1500)
  },
  components: {
    SuccessPopup,
    CropImagePopup,
    Footer,
    Header,
    Sidebar,
    // PhoneVerifyPopup,
    ServerErrorPopup,
    GeneralSelect,
    GeneralCustomCheckBox,
  },
}
</script>

<style scoped>

.password-svg {
  width: 22px;
  height: 22px;
}

.password-svg.show {
  display: block;
}

.password-svg.hide {
  display: none;
}

.error-profile {
  color: red;
}

@media only screen and (max-width: 992px) {
  .registration-field-wrap.textarea-field-wrap, .registration-field-wrap.textarea-field-wrap .registration-field-wrap {
    width: 100%;
  }
}

/* disable hover on mobile */
@media only screen and (min-width: 992px) {
  .profile-form-user-photo-bar {
    /*display: none;*/
    opacity: 0;
  }

  .profile-form-user-photo-bar:hover,
  .profile-form-user-photo:hover + .profile-form-user-photo-bar {
    /*display: block;*/
    opacity: 1;
  }

  .profile-form-user-photo-bar-item:hover path {
    fill: #FE0190;
  }
}


</style>
